<template>
  <div>
    <div
      class="searchGeneralGeodir"
      :class="[openSidenav ? isSidenavOpen : isSidenavClose]"
    >
      <TypeAhead
        v-model="data"
        :srcImgLoading="srcImgLoading"
        :classes="classes"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :src="urlGetAutocomplete"
        :getResponse="getResponse"
        :selectFirst="selectFirst"
        :limit="parseInt(limit)"
        :queryParamName="queryParamName"
        :minChars="parseInt(minChars)"
        :delayTime="parseInt(delayTime)"
        :onHit="onHit"
        :highlighting="highlighting"
        :render="render"
        :fetch="fetch"
        :clean="cleanSearchGeneral"
        @keyup.enter.native="enter"
      ></TypeAhead>
    </div>
    <el-dialog
      title="Ingrese un número de DNI, RUC, SOT o Carnet de Extranjería"
      :visible.sync="centerDialogDni"
      width="30%"
      center
    >
      <select v-model="document" class="select-css" id="documents">
        <option
          v-for="item in documents"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></option>
      </select>
      <vs-input
        style="margin-top: 20px; width: 100%"
        type="number"
        v-model="dni"
        label="Documento:"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogDni = false">Cancel</el-button>
        <el-button type="primary" @click="searchValidation">Buscar</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Ingrese un número de DNI, RUC, SOT o Carnet de Extranjería"
      :visible.sync="centerDialogDniEnter"
      width="30%"
      center
    >
      <select v-model="document" class="select-css" id="documents">
        <option
          v-for="item in documents"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></option>
      </select>
      <vs-input
        style="margin-top: 20px; width: 100%"
        type="number"
        v-model="dni"
        label="Documento:"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogDniEnter = false">Cancel</el-button>
        <el-button type="primary" @click="update">Buscar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
 
<script>
import axios from "axios";
import TypeAhead from "../templatesComponents/VueSaxGeneralTypeaheadTemplate";

import { mapState, mapMutations } from "vuex";

export default {
  components: {
    TypeAhead,
  },
  data() {
    return {
      urlReverse: "",
      isSidenavOpen: "openSidenav",
      isSidenavClose: "closedSidenav",
      data: "",
      openSidenav: false,
      access_token: process.env.VUE_APP_TOKEN_APIS,
      store_ubigeo: this.$store.getters.store_getUbigeo,
      urlGetAutocomplete: "",
      selectFirst: true,
      srcImgLoading: "@/assets/images/loading-two.gif",
      limit: 10,
      queryParamName: ":search",
      minChars: 2,
      delayTime: 0,
      placeholder: "Buscar en Geodir Maps",
      autofocus: "autofocus",
      classes: "typeahead searchGeneralTypeahead",
      builder_map: this.$route.query.mapa,
      dataPlaces: null,
      id: this.$route.params.id,
      nombre: "",
      nombre_etiqueta: "",
      direccion_simple: "",
      geojson: this.$route.params.geojson,
      x: null,
      y: null,
      centerDialogDni: false,
      centerDialogDniEnter: false,
      dni: "",
      item: "",
      vue: "",
      document: "DNI",
      documents: [
        { label: "DNI", value: "DNI" },
        { label: "RUC", value: "RUC" },
        { label: "SOT", value: "SOT" },
        { label: "Carnet extranjeria", value: "carnet-extranjeria" },
      ],
    };
  },

  created() {
    console.log("BUSCADOR GENERAL CREADO");
    this.urlGetAutocomplete = process.env.VUE_APP_PLACES_AUTOCOMPLETE;
    this.access_token = process.env.VUE_APP_TOKEN_APIS;
    this.urlReverse = process.env.VUE_APP_GEOCODING;
  },

  mounted() {
    let app = this;

    //validar sesion
    if (app.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      app.access_token = tokenData.data.access_token;
    }

    //Crear URL para servicio autocomplete
    //app.urlGetAutocomplete= process.env.VUE_APP_URL_PLACES + 'source/poi?&search=:search'+'&access_token='+app.access_token;
    app.urlGetAutocomplete =
      this.urlGetAutocomplete + "&key=" + app.access_token;
    //si se logue validar
    this.$store.watch(this.$store.getters.isLoggedIn, (n) => {
      if (!n) {
        app.access_token = process.env.VUE_APP_TOKEN_APIS;
      }
    });

    this.$store.watch(this.$store.getters.isOpenSidenav, (openSidenav) => {
      app.openSidenav = openSidenav;
    });
    //si tiene latitud y longitud
    if (localStorage.getItem("longitude") != null) {
      this.urlGetAutocomplete =
        this.urlGetAutocomplete +
        "&y=" +
        localStorage.getItem("latitude") +
        "&x=" +
        localStorage.getItem("longitude");
    } else {
      this.urlGetAutocomplete = this.urlGetAutocomplete + "&y=0.0&x=0.0";
    }

    let that = this;

    if (this.$route.params.tipo == "coordinate") {
      setTimeout(function () {
        let y = that.$route.params.y;
        let x = that.$route.params.x;
        let z = that.$route.params.z;
        let layerMarker = that.$store.getters.layerMarkerSearcher;

        if (layerMarker) {
          that.map.removeLayer(layerMarker);
        }

        let lat = that.$route.params.nombre.split(",")[0];
        let lng = that.$route.params.nombre.split(",")[1];

        let latlngMap = new L.latLng(y, x);
        that.map.setView(latlngMap, z);

        let latlngMarker = new L.latLng(lat, lng);

        setTimeout(function () {
          that.layerResult = L.marker(latlngMarker).addTo(that.map);
        }, 300);

        that.$store.commit("SET_LAYER_MARKER", that.layerResult);
        that.$store.commit("setQuery", that.$route.params.nombre);
      }, 100);
    }

    /*const url = process.env.VUE_APP_URL_PLACES;
    var urlget = url + "findid";

    if (this.$route.params.tipo == "place") {
      axios
        .get(urlget, {
          params: {
            id: this.id,
            access_token: "c7fab301-31d8-4618-b452-bc82e361d9bf",
          },
        })
        .then((response) => {
          console.log("respuesta");
          console.log(response.data);

          this.dataPlaces = response.data;
          this.nombre = this.dataPlaces.map((response) => response.nombre);
          this.nombre_etiqueta = this.dataPlaces.map(
            (response) => response.nombreEtiqueta
          );
          this.direccion_simple = this.dataPlaces.map(
            (response) => response.direccionSimple
          );
          this.geojson = this.dataPlaces.map((response) => response.geojson);

          let y = this.$route.params.y;
          let x = this.$route.params.x;
          let z = this.$route.params.z;

          let layerMarker = this.$store.getters.layerMarkerSearcher;

          if (layerMarker) {
            this.map.removeLayer(layerMarker);
          }

          var latlngt = new L.latLng(y, x);

          this.geojson = JSON.parse(this.geojson);

          this.geojsonLayer = L.geoJson(this.geojson);
          //this.map.fitBounds(this.geojsonLayer.getBounds(),{maxZoom: 18});

          if (this.geojson.type == "Point") {
            let latlngt = new L.latLng(y, x);
            this.map.setView(latlngt, 17);
          }
          if (this.geojson.type != "Point") {
            this.map.fitBounds(this.geojsonLayer.getBounds());
          }

          //this.map.setView(latlngt, z);

          const that = this;

          console.log("DIBUJAR");
          console.log(this.geojsonLayer);

          setTimeout(function () {
            that.geojsonLayer
              .bindPopup(that.nombre_etiqueta.toString(), {
                offset: L.point(12, 7),
                autoPan: false,
              })
              .addTo(that.map)
              .openPopup();
          }, 300);

          this.$store.commit("SET_LAYER_MARKER", this.geojsonLayer);
          this.$store.commit(
            "setQuery",
            this.nombre + " " + this.direccion_simple
          );
        });
		}*/
  },
  computed: {
    ...mapState(["map", "query", "latitud_general", "longitud_general"]),
  },
  watch: {
    query: function (val) {
      this.data = this.query;
    },
    $route: function () {
      this.builder_map = this.$route.query.mapa;
    },
  },
  methods: {
    enter() {
      this.dni = "";
      //this.centerDialogDniEnter = true;
      this.update();
    },
    update() {
      console.log("******************");
      console.log("update");

      /* switch (this.document) {
        case "DNI":
          if (this.dni.length != 8) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de un DNI",
              type: "warning",
            });
            return;
          }

          if (this.dni == "00000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }

          break;
        case "RUC":
          if (this.dni.length != 11) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de un RUC",
              type: "warning",
            });
            return;
          }

          if (this.dni == "00000000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        case "SOT":
          if (this.dni.length != 8) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de SOT",
              type: "warning",
            });
            return;
          }
          if (this.dni == "00000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        case "carnet-extranjeria":
          if (this.dni.length != 12) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud del carnet de extranjeria",
              type: "warning",
            });
            return;
          }
          if (this.dni == "000000000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        default:
        // code block
      } */

      let coordinates = this.data;

      if (coordinates.trim().includes(" ")) {
        var code = coordinates.trim().split(" ");
        var lat = code[0];
        var lng = code[1];
      }
      if (coordinates.trim().includes(",")) {
        var code = coordinates.trim().split(",");
        var lat = code[0].trim();
        var lng = code[1].trim();
      }

      this.$store.commit("SET_LATITUD_GENERAL", lat);
      this.$store.commit("SET_LONGITUD_GENERAL", lng);

      if (Number.isInteger(parseInt(lat)) && Number.isInteger(parseInt(lng))) {
        /*this.$router.push({
          name: "coordinate",
          params: {
            tipo: "coordinate",
            nombre: lat + "," + lng,
            y: lat,
            x: lng,
            z: 17,
          },
        });*/

        this.readCoordinates(lat, lng);
      }
    },

    checkLogin() {
      return this.$store.state.isLoggedIn;
    },

    getResponse(response) {
      return response.data.predictions;
    },

    onHit: function (item, vue, index) {
      console.log("hit");
      console.log(item);
      this.item = item;
      this.vue = vue;

      //this.centerDialogDni = true;
      this.searchValidation();
    },

    searchValidation() {
      /*
      switch (this.document) {
        case "DNI":
          if (this.dni.length != 8) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de un DNI",
              type: "warning",
            });
            return;
          }

          if (this.dni == "00000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }

          break;
        case "RUC":
          if (this.dni.length != 11) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de un RUC",
              type: "warning",
            });
            return;
          }

          if (this.dni == "00000000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        case "SOT":
          if (this.dni.length != 8) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud de SOT",
              type: "warning",
            });
            return;
          }
          if (this.dni == "00000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        case "carnet-extranjeria":
          if (this.dni.length != 12) {
            this.$notify({
              title: "Aviso",
              message: "No coincide con la longitud del carnet de extranjeria",
              type: "warning",
            });
            return;
          }
          if (this.dni == "000000000000") {
            this.$notify({
              title: "Aviso",
              message: "DNI invalido",
              type: "warning",
            });
            return;
          }
          break;
        default:
        // code block
      }*/

      this._drawPointMarker(this.item);

      this.$store.commit("setQuery", this.item.description);

      this.vue.query = this.query;
    },

    _drawPointMarker(item) {
      let layerMarker = this.$store.getters.layerMarkerSearcher;

      let self = this;

      if (layerMarker) {
        this.map.removeLayer(layerMarker);
      }

      // obtener coordenadas
      // place_id

      let urlPlaceDetail =
        process.env.VUE_APP_PLACES_DETAILS +
        `place_id=${item.place_id}&key=${self.access_token}&detail=${this.document}:${this.dni}`;

      axios
        .get(urlPlaceDetail)
        .then(function (response) {
          console.log("Se obtuvo el detail correctamente");
          console.log(response);

          self.resultPlaceDetail(response.data);
          self.centerDialogDni = false;
          self.dni = "";
          //resolve(response.data);
        })
        .catch(function (error) {
          console.log(error);
          self.centerDialogDni = false;
          self.dni = "";
          //reject(error);
        });

      /*this.geojson = JSON.parse(item.geojson);
      this.geojsonLayer = L.geoJson(this.geojson);

      if (this.geojson.type == "Point") {
        let latlngt = new L.latLng(item.y, item.x);
        this.map.setView(latlngt, 17);
      }
      if (this.geojson.type != "Point") {
        this.map.fitBounds(this.geojsonLayer.getBounds());
      }*/

      /*const that = this;

      setTimeout(function () {
        that.geojsonLayer
          .bindPopup("" + item.nombreEtiqueta, {
            offset: L.point(12, 7),
            autoPan: false,
          })
          .addTo(that.map)
          .openPopup();
      }, 300);

      this.$store.commit("SET_LAYER_MARKER", this.geojsonLayer);*/
    },

    resultPlaceDetail(result) {
      console.log("resultados del place");

      let self = this;
      if (result.status == "OK") {
        console.log("resultado ok");
        var customIcon = new L.Icon({
          iconUrl: require("../../assets/images/icon_marker.png"),
          iconAnchor: [12, 30],
        });

        let coordinates = result.geometry.coordinates;

        self.$store.commit("SET_LATITUD_GENERAL", coordinates.lat);
        self.$store.commit("SET_LONGITUD_GENERAL", coordinates.lon);

        let place_id = result.place_id;
        this.$store.commit("SET_PLACE_ID", place_id);

        let address = result.standard_address;
        this.$store.commit("SET_ADDRESS", address);

        var latlng = L.GeoJSON.coordsToLatLng([
          coordinates.lon,
          coordinates.lat,
        ]);

        self.map.setView(latlng, 18, {
          duration: 1,
        });

        var marker = L.marker(latlng, { icon: customIcon })
          .addTo(self.map)
          .bindPopup(result.standard_address)
          .openPopup();

        this.$store.commit("SET_LAYER_MARKER", marker);
      }
    },

    readCoordinates(lat, lng) {
      var self = this;

      let layerMarker = this.$store.getters.layerMarkerSearcher;

      if (layerMarker) {
        this.map.removeLayer(layerMarker);
      }

      //  buscar coordenadas reevrse
      var customIcon = new L.Icon({
        iconUrl: require("../../assets/images/icon_marker.png"),
        iconAnchor: [12, 30],
      });

      console.log("buscar reverse");
      let urlSearch = `${this.urlReverse}latlon=${lat},${lng}&key=${this.access_token}`;

      axios.get(urlSearch).then((response) => {
        let dataReverse = response.data;

        if (dataReverse.status == "ZERO_RESULTS") {
          console.log("no hay ningun resultado");
          this.$notify({
            title: "Aviso",
            message: "No se encuentra una direccion para estas coordenadas",
            type: "warning",
          });
          var latlngt = new L.latLng(lat, lng);

          self.map.setView(latlngt, 18, {
            duration: 1,
          });
          // agrgar marcador
          self.marker = L.marker(latlngt, { icon: customIcon })
            .addTo(self.map)
            .openPopup();
        } else {
          let result = dataReverse.results[0];
          var latlngt = new L.latLng(lat, lng);

          self.map.setView(latlngt, 18, {
            duration: 1,
          });

          // agrgar marcador
          self.marker = L.marker(latlngt, { icon: customIcon })
            .addTo(self.map)
            .bindPopup(result.standard_address)
            .openPopup();

          let place_id = result.place_id;
          let address = result.standard_address;

          this.$store.commit("SET_LAYER_MARKER", self.marker);

          this.$store.commit("SET_PLACE_ID", place_id);
          this.$store.commit("SET_ADDRESS", address);
        }
      });

      this.dni = "";
      this.centerDialogDniEnter = false;
    },

    highlighting: function (item, vue) {
      let valueFinal = "";

      let placeResult = item.main_text; // plaza vea
      let querySearch = vue.query; // plaza

      let regExQuerySearch = new RegExp(querySearch, "gi");
      let resultsSearchRegex = placeResult.match(regExQuerySearch);

      var wordSearched = "";
      if (resultsSearchRegex) {
        wordSearched = resultsSearchRegex[0];
      }

      let replaceMask = `<span class="spanwordSearcher">${wordSearched}</span>`;
      let worFinalName = placeResult.replace(wordSearched, replaceMask);
      //let valueNameSearchedReplaced = valueNameSearched;

      if (typeof item === "object") {
        valueFinal =
          worFinalName +
          " " +
          `<span class="spandirectionSearcher">${item.secondary_text}</span>`;
      } else {
        valueFinal = item;
      }

      return valueFinal;
    },
    render: function (items, vue) {
      let newItem = [...items];

      return newItem;
    },
    fetch: function (url) {
      return axios.get(url);
    },
    cleanSearchGeneral() {
      //this.$router.push('/')
      console.log("rutaS");
      console.log(this.$route);
      console.log(this.$router);
      console.log("enrutar");

      /*if (this.$route.name == "place") {
        console.log("enrutar base");
        this.$router.push("/");
      } else if (this.$route.name == "placedelivery") {
        console.log("enrutar vertical");
        this.$router.push("/delivery");
      } else if ((this.$route.name = "placecoronavirus")) {
        console.log("coronavirus");
        this.$router.push("/coronavirus");
      }*/
      //this._enroutingBase();

      let layerMarker = this.$store.getters.layerMarkerSearcher;

      if (layerMarker) {
        this.map.removeLayer(layerMarker);
      }
    },
    _enroutingBase() {},
  },
};
</script>

<style>
.searchGeneralGeodir {
  top: 10px;
  position: fixed;
  text-align: left;
  transition: 0.22s;
  width: 340px;
  height: 48px;
  background-color: #fff;
  z-index:  10000 !important ;
  display: inline-block;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0 rgba(0, 0, 0, 0.02);
}

.searchGeneralGeodir ul.typehead {
  margin-top: 0px !important;
  left: -48px !important;
  min-width: 388px !important;
}

@media screen and (max-width: 500px) {
  .searchGeneralGeodir {
    top: 10px;
    position: fixed;
    text-align: left;
    transition: 0.22s;
    height: 48px;
    background-color: #fff;
    z-index: 10000 !important;
    display: inline-block;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0 rgba(0, 0, 0, 0.02);
    width: 72%;
    display: inline-block;
  }

  .searchGeneralGeodir ul.typehead {
    margin-top: 0px !important;
    left: -48px !important;
    min-width: 340px !important;
  }
}
/*@media(max-width: 500px) {
	
}*/

.openSidenav {
  left: 378px;
}

.closedSidenav {
  left: 58px;
}

/*.el-input__inner {
		height: 48px !important;
		padding: 0px !important;
		font-size: 15px !important;
	}*/

.el-input__inner::placeholder {
  color: #6c757d !important;
}

/*ul.typehead {
		margin-top: 0px !important;
		left: -48px !important;
	}*/

.searchGeneralTypeahead.isFocus {
  border: none !important;
}

.searchGeneralTypeahead .vs-input--input {
  padding: 9px !important;
}

.searchGeneralTypeahead .el-input__inner {
  border-radius: 0px !important;
  border: none !important;
}

/* Cada elemento de la lista */
.searchGeneralGeodir li.listTypehead {
  font-size: 13px !important;
  color: #333 !important;
}

/* Texto que se ingreso en el buscador resaltado en las respuestas */
.spanwordSearcher {
  font-weight: 500;
  color: #0a0a0a;
}

/* Texto de informacion adicional al place realizado*/
.spandirectionSearcher {
  color: #8c8c8c;
}

.searchGeneralTypeahead.vs-input-primary .vs-input--input:focus {
  border: none !important;
}

.searchGeneralTypeahead .vs-input--input {
  border: none !important;
  height: 48px;
  font-size: 15px;
  padding-right: 45px !important;
}

.searchGeneralGeodir .input-span-placeholder {
  padding-left: 5px !important;
}

.select-css {
  display: block;
  font-size: 16px;
  font-family: sans-serif;
  font-weight: 700;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%; /* useful when width is set to anything other than 100% */
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  /* note: bg image below uses 2 urls. The first is an svg data uri for the arrow icon, and the second is the gradient. 
    for the icon, if you want to change the color, be sure to use `%23` instead of `#`, since it's a url. You can also swap in a different svg icon or an external image reference
    
  */
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  /* arrow icon position (1em from the right, 50% vertical) , then gradient position*/
  background-position: right 0.7em top 50%, 0 0;
  /* icon size, then gradient */
  background-size: 0.65em auto, 100%;
}
/* Hide arrow icon in IE browsers */
.select-css::-ms-expand {
  display: none;
}
/* Hover style */
.select-css:hover {
  border-color: #888;
}
/* Focus style */
.select-css:focus {
  border-color: #aaa;
  /* It'd be nice to use -webkit-focus-ring-color here but it doesn't work on box-shadow */
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}

/* Set options to normal weight */
.select-css option {
  font-weight: normal;
}

/* Support for rtl text, explicit support for Arabic and Hebrew */
*[dir="rtl"] .select-css,
:root:lang(ar) .select-css,
:root:lang(iw) .select-css {
  background-position: left 0.7em top 50%, 0 0;
  padding: 0.6em 0.8em 0.5em 1.4em;
}

/* Disabled styles */
.select-css:disabled,
.select-css[aria-disabled="true"] {
  color: graytext;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22graytext%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
}

.select-css:disabled:hover,
.select-css[aria-disabled="true"] {
  border-color: #aaa;
}
</style>


